{
    "ModalTitleMc": "Faça uma ligação",
    "ModalTitleTo": "Enviar chamada para",
    "ModalTitleMcc": "Transferência de consulta para",
    "SubTitle": "Escolha o número de telefone",
    "SelectLabel": "Número de telefone:",
    "SelectPlaceholder": "por exemplo, 01234567899",
    "SelectNoItems": "Número desconhecido",
    "FooterHelp": "Ajuda",
    "FooterOk": "OK",
    "FooterClose": "Perto",
    "CallTargetting_Description": "Selecione um dispositivo de destino interno na lista ou insira manualmente o número de telefone de destino.",
    "NAME": "CallTargetting"
}